import { cf } from "@wb/ui/analytics/cf";
import { state } from "@wb/ui/analytics/state";
import { type FC, useEffect } from "react";
import { z } from "zod";

const schema = z.object({
  id: z.string(),
});

type Props = z.infer<typeof schema>;

export const CloudflareAnalytics: FC<Props> = ({ id }) => {
  useEffect(() => {
    state.instances.push(cf);
  }, []);

  return (
    <script
      defer
      src="https://static.cloudflareinsights.com/beacon.min.js"
      data-cf-beacon={JSON.stringify({ token: id })}
    />
  );
};
